import React from "react";
import { useParams } from "react-router-dom";
import { ConnectedInfo } from "../../../client-chat-page/ConnectedInfo";

export const VerbindungPage: React.FC = () => {
	const { clientId } = useParams();
	return (
		<div className="p-6">
			<div className="max-w-6xl">
				<h1 className="text-2xl font-semibold text-gray-900 mb-6">
					dentCONNECT
				</h1>
				<ConnectedInfo clientId={clientId || ""} />
			</div>
		</div>
	);
};
